import React from 'react'
import makeStyles from '@mui/styles/makeStyles'
import classNames from 'classnames'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { tokens } from '../../styles/tokens'

const useStyles = makeStyles(() => ({
  group: {
    backgroundColor: tokens.color.neutral[50],
    border: `1px solid ${tokens.color.neutral[200]}`,
    borderRadius: tokens.radius.full,
    padding: '2px',
    gap: '2px',
  },
  button: {
    border: 'none',
    borderRadius: `${tokens.radius.full} !important`,
    padding: '4px 16px',
    minWidth: 0,
    fontSize: '0.75rem',
    fontWeight: tokens.font.weight.medium,
    color: tokens.color.neutral[600],
    textTransform: 'none',
    transition: `background-color ${tokens.transition.fast}, color ${tokens.transition.fast}`,
    '&:hover': {
      backgroundColor: tokens.color.primary[100],
    },
    '&.Mui-selected': {
      backgroundColor: tokens.color.primary[700],
      color: tokens.color.white,
    },
    '&.Mui-selected:hover': {
      backgroundColor: tokens.color.primary[800],
    },
  },
}))

interface YearQuickFilterProps {
  years: number[]
  selectedYear: number | null
  onSelectYear: (year: number) => void
  className?: string
}

export const YearQuickFilter: React.FC<YearQuickFilterProps> = ({ years, selectedYear, onSelectYear, className }) => {
  const classes = useStyles()

  const handleChange = (_event: React.MouseEvent<HTMLElement>, value: number | null) => {
    if (value !== null) {
      onSelectYear(value)
    }
  }

  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={selectedYear}
      onChange={handleChange}
      className={classNames(classes.group, className)}
    >
      {years.map(year => (
        <ToggleButton key={year} value={year} className={classes.button} disableRipple>
          {year}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}
